import { useLanguage } from "../hooks/useLanguage"

export default function Faq() {
  const { t } = useLanguage()
  const f = t.faq

  return (
    <section id="faq" className="gms-wrap flex flex-wrap items-start gap-x-[72px] gap-y-10 pt-section">
      <div className="min-w-0 flex-[1_1_320px]">
        <div className="gms-eyebrow">{f.eyebrow}</div>
        <h2 className="gms-h2">{f.title}</h2>
        <p className="mt-5 max-w-[360px] text-[17px] leading-[1.55] text-gms-muted">
          {f.helpStart}
          <a href={t.contactInfo.whatsappUrl} target="_blank" rel="noopener noreferrer" className="font-semibold text-gms-ink underline">
            {f.helpLink}
          </a>
          .
        </p>
      </div>

      <div className="min-w-0 flex-[2_1_560px] border-b border-gms-line">
        {f.items.map(({ q, a }, i) => (
          <details key={q} open={i === 0} className="border-t border-gms-line">
            <summary className="flex min-h-[44px] cursor-pointer list-none items-center justify-between gap-6 py-6 text-[clamp(18px,1.5vw,20px)] font-semibold tracking-[-0.02em]">
              {q}
              <span
                aria-hidden="true"
                className="gms-plus inline-flex h-9 w-9 flex-none items-center justify-center rounded-full bg-gms-mist text-[22px] font-normal"
              >
                +
              </span>
            </summary>
            <p className="mb-[26px] max-w-[720px] text-[16px] leading-[1.6] text-gms-muted">{a}</p>
          </details>
        ))}
      </div>
    </section>
  )
}
